import socketio from 'socket.io-client';

const getUrlFormated = url => {
  if (url.indexOf("http:") === 0 || url.indexOf("https:") === 0) {
    return url;
  }
  return window.location.protocol === "https:"
         ? `https://${url}`
         : `http://${url}`;
};

const url = getUrlFormated(process.env.REACT_APP_SOCKET_URL);

const socket = socketio(url, {
  autoConnect: false,
  path: '/socket.io',
  transports: ['websocket'],
  secure: true,
});

// o painel do síndico envia o token para poder moderar e escrever como síndico no chat
function connect() {
  try {
    const token = localStorage[process.env.REACT_APP_LOCALSTORAGE_AUTH_TOKEN];
    socket.io.opts.query = token ? { token } : {};
  } catch (e) {
    socket.io.opts.query = {};
  }
  socket.connect();
}

function disconnect() {
  if (socket.connected) {
    socket.disconnect();
  }
}

export {connect, disconnect, socket};
